@use '../../../../app/styles/common/mixins';

.wrapper {
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 28px;
  gap: var(--spasing20);

  @include mixins.tablet {
    margin-bottom: 48px;
  }

  @include mixins.laptop {
    margin-bottom: 0;
  }

  &.expired {
    opacity: 0.5;
  }

  &.placeholder {
    .mainGallery {
      overflow: hidden;
    }

    .thumbsGallery {
      flex-direction: column;
      gap: var(--spasing08);
    }

    .thumbsSlide {
      isolation: isolate;

      &:first-of-type {
        outline: 2px solid var(--border-accent-dark);
        outline-offset: -2px;
      }
    }
  }
}

.thumbsGalleryWrapper {
  display: none;
  position: relative;

  @include mixins.laptop {
    &.moreThanOne {
      display: flex;
    }
  }
}

.mainGalleryWrapper {
  position: relative;
  width: 100%;

  margin: 0 auto;

  @include mixins.laptop {
    // NOTE: allow the main image area to shrink to fit the column
    min-width: 0;
  }

  @include mixins.desktop {
    min-width: 520px;
  }
}

.mainGalleryWrapper,
.thumbsGalleryWrapper {
  height: 398px;

  @include mixins.laptop {
    height: 432px;
  }

  @include mixins.desktop {
    height: 520px;
  }
}

.galleryArrowsWrapper {
  position: absolute;
  inset: 0;
  display: flex;
  z-index: 2;
}

.galleryArrowWrapper,
.gallerySlide {
  cursor: zoom-in;
}

.gallerySlide {
  height: 100%;
}

.galleryArrowWrapper {
  flex: 1 1 50%;

  &:hover {
    .galleryArrow {
      opacity: 1;
    }
  }
}

.galleryArrow {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  position: absolute;
  border: none;
  width: 40px;
  top: 0;
  bottom: 0;

  // stylelint-disable-next-line
  background-color: rgb(0 0 0 / 15%);
  transition: opacity 0.15s;

  &:disabled {
    display: none;
  }

  svg {
    flex-shrink: 0;
  }
}

.galleryArrowNext {
  right: 0;
  border-radius: 0 var(--rounding16) var(--rounding16) 0;
}

.galleryArrowPrev {
  left: 0;
  border-radius: var(--rounding16) 0 0 var(--rounding16);
}

// Scoped under the gallery wrappers so the 16px radius deterministically beats
// the Image atom's own single-class 12px `.container` radius — an unscoped
// selector ties with it and loses/wins by CSS chunk load order (BP-8082).
.mainGallery .galleryImage,
.thumbsGallery .thumbImage {
  border-radius: var(--rounding16);

  @include mixins.laptop {
    border-radius: 0;
  }
}

.thumbImage {
  // NOTE: to make outline visible
  z-index: -1;
}

.mainGallery {
  height: 100%;
  margin: 0 calc(var(--spasing16) * -1);
  padding: 0 var(--spasing16);

  @include mixins.laptop {
    margin: 0;
    padding: 0;
    border-radius: var(--rounding16);
  }
}

// BP-8082: pill-shaped dots indicator overlaid bottom-center on the photo
// (same absolute-bullets pattern as FeedCard/SwiperCarousel). z-index 1 keeps
// it under the gallery arrows (2) and the stats toast (3).
.bullets {
  position: absolute;
  bottom: var(--spasing08);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;

  display: flex;
  align-items: center;
  gap: var(--spasing06);

  height: 12px;
  padding: 0 var(--spasing08);
  border-radius: var(--rounding_full);

  // TODO(BP-8082): Figma token overlay/bg-medium (--neutral-1000 @ 60%) is not
  // yet present in tokens.generated.css; swap the hardcoded color once the
  // overlay/* group lands in the tokens sync.
  // stylelint-disable-next-line
  background-color: rgb(20 20 20 / 60%);

  // No empty pill between SSR first paint and Swiper's pagination render.
  &:empty {
    display: none;
  }

  @include mixins.laptop {
    display: none;
  }
}

.bullet {
  width: 4px;
  height: 4px;
  border-radius: 50%;

  // The pill sits on the photo, so the dots are intentionally theme-independent
  // white (Figma: active white, inactive white @ 40%).
  // stylelint-disable-next-line
  background-color: var(--white-0-40);
}

.bulletActive {
  background-color: var(--static-white);
}

.thumbsGallery {
  width: 100%;
  display: flex;

  @include mixins.laptop {
    width: 65px;
  }

  @include mixins.desktop {
    width: 80px;
  }
}

.thumbsSlide {
  width: 100%;
  border-radius: var(--rounding16);
  overflow: hidden;
  cursor: pointer;

  @include mixins.laptop {
    height: 65px;
  }

  @include mixins.desktop {
    height: 80px;
  }
}
